import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

const Title = ({ title, color, size }) => {
  const useStyles = makeStyles((theme) => ({
    title: {
      fontSize: 60,
      fontFamily: "Gotham Rounded",
      textTransform: "uppercase",
      color: theme.palette[color].main,
      letterSpacing: -1,
      maxWidth: size === "lg" ? 800 : size === "md" ? 650 : 550,
      lineHeight: 1.1,
      textAlign: "left",
      [theme.breakpoints.down("md")]: {
        maxWidth: "100%",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: 40,
      },
    },
  }));
  const classes = useStyles();
  return <h1 className={classes.title}>{title}</h1>;
};

Title.propTypes = {
  title: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
};

export default Title;
